// MY BESTIE CHECKOUT *****************************************************************************
// pathname: /v1/my-bestie
// Creates a Stripe checkout payment intent for the My Bestie service.
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrMyBestieCheckoutProps {
  locale: string;
  successCallback?: (response: ApiSchema<'CartOrderResponse'>) => Promise<void> | void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: create a Stripe checkout session for My Bestie service.
 * - `locale` string - the locale to use for the request.
 * - `successCallback` function - called after a successful response.
 * - `errorCallback` function - called on error.
 */
export const useSwrMyBestieCheckout = (props: UseSwrMyBestieCheckoutProps) => {
  const { locale, successCallback, errorCallback } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'CartOrderResponse'>, ApiSchema<'UserOrderRequest'>>({
    url: '/v1/my-bestie',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (response) => {
        if (successCallback) void successCallback(response);
      },
      onError: () => {
        if (errorCallback) errorCallback();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  return {
    data, error, isMutating, reset, trigger,
  };
};
